import { ActionTypes as types } from '../constant';

let initialState = {
  playVideo: false,
  stopVideo: false,
  autoPlay: true,
};

export default function charity(state = initialState, action) {
  // if state is not available, initial state is taken

  switch (action.type) {
    case types.START_VIDEO_PLAY:
      return {
        ...state,
        videoIndex: action.data.videoIndex,
        playVideo: action.data.playVideo,
        stopVideo: action.data.stopVideo,
        autoPlay: action.data.autoPlay,
      };
    case types.STOP_VIDEO_PLAY:
      return {
        ...state,
        videoIndex: action.data.videoIndex,
        playVideo: action.data.playVideo,
        stopVideo: action.data.stopVideo,
        autoPlay: action.data.autoPlay,
      };
    default:
      return state;
  }
}
